import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

const PdfViewerDialog = ({ pdfUrl, onClose, title }) => {
  return (
    <ConfirmationDialog
      contentPadding="0"
      onClose={onClose}
      maxWidth="85vw"
      hasConfirmButton={false}
      title={title}
    >
      <iframe
        title="pdf"
        src={pdfUrl}
        style={{ width: '80vw', height: '80vh', maxWidth: 1000, maxHeight: 950 }}
      />
    </ConfirmationDialog>
  )
}

export default PdfViewerDialog
